module.exports = __webpack_public_path__ + "facelifting_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/facelifting_5_after_tn.jpg
// module id = 1525
// module chunks = 0